module.exports = __webpack_public_path__ + "img/noticias.e6269d5e.svg";